module.exports = __webpack_public_path__ + "static/media/af.4bde7719.svg";